export default {
  root: ({ props, context, parent }) => ({
    class: [
      // Font
      'font-sans leading-none tracking-tight',

      // Flex
      { 'flex-1 w-[1%]': parent.instance.$name == 'InputGroup' },

      // Spacing
      'm-0',
      {
        'px-4 py-4': props.size == 'large',
        'px-2 py-2': props.size == 'small',
        'p-3': props.size == null
      },

      // Shape
      { 'rounded-lg': parent.instance.$name !== 'InputGroup' },
      {
        'first:rounded-l-md rounded-none last:rounded-r-md': parent.instance.$name == 'InputGroup'
      },
      { 'border-0 border-y border-l last:border-r': parent.instance.$name == 'InputGroup' },
      { 'first:ml-0 -ml-px': parent.instance.$name == 'InputGroup' && !props.showButtons },

      // Colors
      'text-neutral-600 dark:text-neutral-200',
      'placeholder:text-neutral-400 dark:placeholder:text-neutral-500',
      'bg-neutral-0 dark:bg-neutral-900',
      'border',
      { 'border-neutral-300/80 dark:border-neutral-600': !props.invalid },

      // Invalid State
      { 'border-red-500 dark:border-red-400': props.invalid },

      // States
      {
        'hover:border-neutral-500 dark:hover:border-neutral-400':
          !context.disabled && !props.invalid,
        'focus:outline-none focus:outline-offset-0 focus:ring-1 focus:ring-primary-300 focus:border-primary-300 dark:focus:ring-neutral-400/50 focus:z-10':
          !context.disabled,
        'opacity-60 select-none pointer-events-none cursor-default': context.disabled,
        'focus:ring-red-500 dark:focus:ring-red-400': props.invalid
      },

      // Filled State *for FloatLabel
      { filled: parent.instance?.$name == 'FloatLabel' && context.filled },

      // Misc
      'appearance-none',
      'transition-colors duration-200'
    ]
  })
}
